import { Col, Row, } from "antd";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import { useGetContractByType } from "apps/CustomerPanel/Ad/ServerSideStates";
import { FC } from "react";

const CorporateAccountAgreement:FC<{containerClassNames?:string}> = ({containerClassNames}) => {
  const contract = useGetContractByType("2")
  

	const html = contract?.data?.data?.content || "";
	return (
	  <Col xs={24}>
		<Row className={containerClassNames?containerClassNames:"!px-16"} gutter={[20, 20]}>
		  {contract.isLoading ? (
			<>
			  <GeneralLoadingSpinner />
			</>
		  ) : (
			<>
			  <Col xs={24}>
				<div dangerouslySetInnerHTML={{ __html: html }} />
			  </Col>
			</>
		  )}
		</Row>
		
	  </Col>
	);

  
};

export default CorporateAccountAgreement;
